/**
 * The two `EvidenceAnswerPorts` members only Chat may name (ruling 62), filled
 * into the app-shell host's slot at module scope.
 *
 * `constants/integrationPartners.ts` reads the query cache during render and
 * has fifteen importers; `SourceCardActions` carries a twelve-file feedback
 * subgraph and one of K8's two app-only blockers. Neither moves. Both are
 * inside the Chat quarantine globs, so this — a Chat file — is the only place
 * that may bind them without opening a new inbound pair.
 */

import { registerEvidenceAnswerChatPorts } from '@/composition/hosts/evidence-answer-chat-ports';

import { getPartnerConfig } from '../constants/integrationPartners';
import { SourceCardActions } from './SourceCardActions';

registerEvidenceAnswerChatPorts({
  getPartnerConfig,
  sourceActionsComponent: SourceCardActions,
});
